import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Link from '../../../Core/Link';

import { Wrapper, Header, StyledContainer, Block, StyledImage } from './styles';

//  * headingSection_1 {RichText} heading for the first card (left)
//  * textSection_1 {RichText} bodyCopy for the first card (left)
//  * ctaLabelSection_1 {string} innerText of the CTA on for the first card (left)
//  * ctaSection_1 {obj} url for the cta in the first card (left)
//  * headingSection_2 {RichText} heading for the second card (right)
//  * textSection_2 {RichText} bodyCopy for the second card (right)
//  * ctaLabelSection_2 {string} innerText of the CTA on for the second card (right)
//  * ctaSection_2 {obj} url for the cta in the second card (right)
//  * imageLeft {obj} the data for the image in the first card (left)
//  * imageRight {obj} the data for the image in the second card (right)
//  * title {RichText} Heading for enitre section
//  * subHeading {RichText} Subheading for enitre section

const DualColorBlock = ({ data, className }) => {
  if (!data) return null;
  const {
    headingSection_1Html,
    textSection_1Html,
    ctaLabelSection_1,
    ctaSection_1,
    headingSection_2Html,
    textSection_2Html,
    ctaLabelSection_2,
    ctaSection_2,
    imageLeft,
    imageLeftSharp,
    imageRight,
    imageRightSharp,
    title,
    titleHtml,
    subHeading,
    subHeadingHtml,
    ctaType,
    ctaType_2,
    colourOverrideBackground_1,
    colourOverrideCardText_1,
    colourOverrideCardText_2,
    queryString_2,
    queryString_1,
    ariaLabel_1,
    ariaLabel_2,
  } = data;

  return (
    <Wrapper
      className={[className, (imageLeft.url || imageRight.url) && 'with-image']}
      colourOverrideBackground_1={colourOverrideBackground_1}
    >
      {(title.length > 0 || subHeading.length > 0) && (
        <Header className="auto-margin">
          {ReactHtmlParser(titleHtml)}
          {ReactHtmlParser(subHeadingHtml)}
        </Header>
      )}
      <StyledContainer className="auto-margin">
        <Block colourOverrideCardText={colourOverrideCardText_1}>
          {imageLeft.url && (
            <StyledImage src={imageLeftSharp} alt={imageLeft.altTag} />
          )}
          {ReactHtmlParser(headingSection_1Html)}
          {ReactHtmlParser(textSection_1Html)}
          <Link
            className={ctaType}
            to={`${ctaSection_1.url}/`}
            queryString={queryString_1}
            ariaLabel={ariaLabel_1}
          >
            {ctaLabelSection_1}
          </Link>
        </Block>
        <Block colourOverrideCardText={colourOverrideCardText_2}>
          {imageRight.url && (
            <StyledImage src={imageRightSharp} alt={imageRight.altTag} />
          )}
          {ReactHtmlParser(headingSection_2Html)}
          {ReactHtmlParser(textSection_2Html)}
          <Link
            className={ctaType_2}
            to={`${ctaSection_2.url}/`}
            queryString={queryString_2}
            ariaLabel={ariaLabel_2}
          >
            {ctaLabelSection_2}
          </Link>
        </Block>
      </StyledContainer>
    </Wrapper>
  );
};

DualColorBlock.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string,
};

DualColorBlock.defaultProps = {
  className: null,
};

export default DualColorBlock;
